/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const documentTileStyle = {
  container: (theme: Theme) => ({
    padding: "0.5rem",
    alignItems: "center",
    backgroundColor: theme.palette.primaryPale,
    borderRadius: "0.25rem",
    justifyContent: "space-between",
  }),
};

export default documentTileStyle;
